// Schadenmelder in der Schadenmappe (das „Wer“, intern vor Abschluss/Prüfen):
// der Melder-Schritt des Wizards ohne die Frage „für wen?“ — das steht durch die
// Kontaktwahl schon fest. Sind die Angaben noch leer, werden sie einmal aus dem
// Kontakt des Schadens vorbelegt (Name, Telefon, E-Mail, soweit vorhanden).
import * as React from "react";
import { apiUrl } from "../../../utils/api";
import { MelderStep } from "../../schadenmeldung-big/steps/shared";
import type { BigAnswers } from "../../schadenmeldung-big/types";
import { melderAusKontakt, melderLeer } from "./vorbelegung";

export interface MelderInternProps {
  answers: BigAnswers;
  update: (patch: Partial<BigAnswers>) => void;
  contactId: number | null;
  kontaktName: string;
}

export function MelderIntern({ answers, update, contactId, kontaktName }: MelderInternProps) {
  const [vorbelegt, setVorbelegt] = React.useState(false);
  // Nur beim Öffnen des Schritts prüfen: wer die Felder danach leert, bekommt sie nicht zurück.
  const leerBeimOeffnen = React.useRef(melderLeer(answers));
  const updateRef = React.useRef(update);
  React.useEffect(() => {
    updateRef.current = update;
  });

  React.useEffect(() => {
    if (contactId === null || !leerBeimOeffnen.current) return;
    let abgebrochen = false;
    fetch(apiUrl(`contact/${contactId}`))
      .then((res) => (res.ok ? res.json() : null))
      .then((row) => {
        if (abgebrochen) return;
        const patch = melderAusKontakt(row);
        if (!patch) return;
        leerBeimOeffnen.current = false;
        updateRef.current(patch);
        setVorbelegt(true);
      })
      .catch(() => undefined);
    return () => {
      abgebrochen = true;
    };
  }, [contactId]);

  return (
    <>
      {vorbelegt && (
        <p className="smp-vorbelegt">
          Vorbelegt aus dem Kontakt{kontaktName ? ` „${kontaktName}“` : ""} — bitte prüfen und bei Bedarf überschreiben.
        </p>
      )}
      <MelderStep
        answers={answers}
        update={update}
        ohneFuerWen
        hint="Wer hat den Schaden gemeldet und ist für Rückfragen erreichbar? Für wen gemeldet wird, steht durch den Kontakt schon fest."
      />
    </>
  );
}
